import { render, staticRenderFns } from "./DesignRirekisho002PreviewDoc.vue?vue&type=template&id=6596f46a"
import script from "./DesignRirekisho002PreviewDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho002PreviewDoc.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports